import React, { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";

const items = [
  { label: "Founded", value: 2019, suffix: "" },
  { label: "Global Partners", value: 150, suffix: "+" },
  { label: "Publisher Network", value: 300, suffix: "+" },
  { label: "Delivered Leads", value: 255, suffix: "K+" },
];

function Counter({ end, suffix }) {
  const [n, setN] = useState(0);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const started = useRef(false);

  useEffect(() => {
    if (inView && !started.current) {
      started.current = true;
      const dur = 1400;
      const start = performance.now();
      const step = (t) => {
        const p = Math.min(1, (t - start) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        setN(Math.floor(eased * end));
        if (p < 1) requestAnimationFrame(step);
        else setN(end);
      };
      requestAnimationFrame(step);
    }
  }, [inView, end]);

  return (
    <span ref={ref} className="text-gold-gradient">
      {n}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section className="relative py-24 border-y border-white/5 bg-[#080808]">
      <div className="absolute inset-0 radial-gold opacity-40 -z-10" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {items.map((it) => (
            <div key={it.label} className="text-center md:text-left">
              <div className="text-5xl md:text-6xl font-semibold tracking-tight">
                <Counter end={it.value} suffix={it.suffix} />
              </div>
              <div className="mt-3 text-xs uppercase tracking-[0.28em] text-white/50">{it.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
